export default {
  SET_GRAPH_DATA: (state, data) => {
    state.graphData = data;
  },
};
